import getCommandBarButtonsForFilesHub from './getCommandBarButtonsForFilesHub';
import getCommandBarButtonsForGroupFilesHub from './getCommandBarButtonsForGroupFilesHub';
import getCommandBarButtonsForMail from './getCommandBarButtonsForMail';
import { assertNever } from 'owa-assert';
import { SxSCustomization, SxSStore } from 'owa-sxs-store';
import { PreviewPaneCommandBarItem } from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';

export default function getCommandBarButtons(sxsStore: SxSStore): PreviewPaneCommandBarItem[] {
    switch (sxsStore.customization) {
        case SxSCustomization.Mail:
        case SxSCustomization.DeepLink:
            return getCommandBarButtonsForMail(sxsStore);
        case SxSCustomization.FilesHub:
            return getCommandBarButtonsForFilesHub(sxsStore);
        case SxSCustomization.GroupFilesHub:
            return getCommandBarButtonsForGroupFilesHub(sxsStore);
        default:
            return assertNever(sxsStore.customization);
    }
}
